import React, { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import CONSTANTS from "../utils/constants";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const socketURL = CONSTANTS.baseRoute.replace("/api", "");
    const newSocket = io(socketURL);
    setSocket(newSocket);

    newSocket.on("newOrder", (newOrder) => {
      console.log("Global yeni sipariş bildirimi alındı");
      const audio = new Audio("/bell.mp3");
      audio.play().catch((err) =>
        console.log("Ses çalma için kullanıcı etkileşimi gerekiyor:", err)
      );
    });

    return () => newSocket.disconnect();
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};